/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import msdyn365Commerce from '@msdyn365-commerce/core-internal';
import { IGtmBodyViewProps } from './gtm-body';

export default (props: IGtmBodyViewProps) => {
    if (msdyn365Commerce.isBrowser) {
        const url = `https://www.googletagmanager.com/ns.html?id=${props.config.gtmId}`;
        const body = document.querySelector('body');
        const exists = !!document.querySelector('#gtm');
        if (body && !exists) {
            const gtm = document.createElement('noscript');
            gtm.id = 'gtm';
            const ifel = document.createElement('iframe');
            ifel.setAttribute('src', url);
            ifel.setAttribute('height', '0');
            ifel.setAttribute('width', '0');
            ifel.setAttribute('style', 'display: none; visibility: hidden;');
            gtm.appendChild(ifel);
            body.prepend(gtm);
        }
    }

    return null;
};
